import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 my-10" }, "Documentos", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 my-10" }, "Dados bancários", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 mb-10" }, "Permissões", -1)

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import {ref, reactive, inject} from 'vue';
import rules from '@/app/shared/domain/data/rules';
import InputAvatar from '@/app/shared/components/inputs/InputAvatar.vue';
import InputCpf from '@/app/shared/components/inputs/InputCpf.vue';
import Collaborator from '@/app/collaborator/domain/interfaces/Collaborator';
import InputCostCenter from '@/app/shared/components/inputs/InputCostCenter.vue';
import InputAddress from '@/app/shared/components/inputs/InputAddress.vue';
import InputBankAccount from '@/app/shared/components/inputs/InputBankAccount.vue';
import CollaboratorRepository from '@/app/collaborator/infrastructure/persistence/CollaboratorRepository';
import Tabs from '@/app/shared/components/Tabs.vue';
import { useForm } from '@/app/shared/ui/composable/form';
import RequestRefund from '@/app/collaborator/components/RequestRefund.vue';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollaboratorForm',
  props: ['id'],
  setup(__props) {

const props = __props;

const notificationRepository = useNotificationRepository();
const repository = inject('collaboratorRepository') as CollaboratorRepository;

const picture = ref(null);
const form = ref(null);

let collaborator = reactive({
    image: 'default.jpg',
} as Collaborator);

const { pageTitle, submitAttach, isEditPage } = useForm(
    props,
    collaborator,
    repository,
    form,
    'Editar colaborador',
    'Cadastrar colaborador',
    '/colaboradores',
    '/colaboradores',
);

function submit() {
    submitAttach(picture.value);
}

const tabItens = [
    {
        icon: 'mdi:mdi-book-open',
        key: 'main',
        title: 'Principal'
    },
    {
        icon: 'mdi:mdi-map-marker',
        key: 'address',
        title: 'Endereço'
    },
    {
        icon: 'mdi:mdi-plus-circle-outline',
        key: 'add',
        title: 'Adicionais'
    },
    {
        icon: 'mdi:mdi-cog-outline',
        key: 'config',
        title: 'Configurações'
    },
];

const changeAccessRule = async (action: 'allow' | 'removeAllow') => {
    if (action === 'allow') {
        await repository.allowPanelAccess(props.id);

        notificationRepository.insert({id: Date.now().toString(), type: 'success', message: 'Permissão concedida com sucesso'});
        
        collaborator.access_panel = true;
    } else {
        await repository.removePanelAccess(props.id);

        notificationRepository.insert({id: Date.now().toString(), type: 'success', message: 'Permissão concedida com sucesso'});

        collaborator.access_panel = false;
    }
};

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: submit,
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Tabs, { itens: tabItens }, {
                        main: _withCtx(() => [
                          _createVNode(_component_v_row, { wrap: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                lg: "2",
                                align: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputAvatar, {
                                    "image-path": "collaborators",
                                    src: _unref(collaborator).image,
                                    modelValue: picture.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((picture).value = $event))
                                  }, null, 8, ["src", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                lg: "10"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputCpf, {
                                            modelValue: _unref(collaborator).document,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(collaborator).document) = $event)),
                                            label: "Cpf"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).required],
                                            label: "Nome",
                                            modelValue: _unref(collaborator).name,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(collaborator).name) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Email",
                                            rules: [_unref(rules).email, _unref(rules).required],
                                            modelValue: _unref(collaborator).email,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(collaborator).email) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Celular / Whatsapp",
                                            rules: [_unref(rules).phone],
                                            modelValue: _unref(collaborator).cell_phone,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(collaborator).cell_phone) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '(##)#####-####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_switch, {
                                            modelValue: _unref(collaborator).is_pdc,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(collaborator).is_pdc) = $event)),
                                            inset: "",
                                            color: "primary",
                                            label: "Pdc?"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        address: _withCtx(() => [
                          _createVNode(InputAddress, {
                            modelValue: _unref(collaborator).address,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(collaborator).address) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        add: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_v_text_field, {
                                    rules: [_unref(rules).date, _unref(rules).futureDate],
                                    label: "Data de nasc.",
                                    modelValue: _unref(collaborator).birthdate,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(collaborator).birthdate) = $event))
                                  }, null, 8, ["rules", "modelValue"]), [
                                    [_directive_mask, '##/##/####']
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_v_text_field, {
                                    label: "Telefone",
                                    rules: [_unref(rules).phone],
                                    modelValue: _unref(collaborator).phone,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(collaborator).phone) = $event))
                                  }, null, 8, ["rules", "modelValue"]), [
                                    [_directive_mask, '(##)####-####']
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputCostCenter, {
                                    modelValue: _unref(collaborator).cost_center_id,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(collaborator).cost_center_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Nome da mãe",
                                    modelValue: _unref(collaborator).mother_name,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(collaborator).mother_name) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Nome do pai",
                                    modelValue: _unref(collaborator).father_name,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(collaborator).father_name) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _hoisted_1,
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_v_text_field, {
                                    label: "Rg",
                                    modelValue: _unref(collaborator).rg,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(collaborator).rg) = $event))
                                  }, null, 8, ["modelValue"]), [
                                    [_directive_mask, '##.###.###-#']
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Pis",
                                    modelValue: _unref(collaborator).pis,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(collaborator).pis) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Cnh",
                                    modelValue: _unref(collaborator).cnh,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(collaborator).cnh) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Nº Ctps",
                                    modelValue: _unref(collaborator).ctps_number,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(collaborator).ctps_number) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Série Ctps",
                                    modelValue: _unref(collaborator).ctps_serie,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(collaborator).ctps_serie) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _hoisted_2,
                          _createVNode(InputBankAccount, {
                            modelValue: _unref(collaborator).account,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(collaborator).account) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        config: _withCtx(() => [
                          _hoisted_3,
                          (_unref(isEditPage))
                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      (!_unref(collaborator).access_panel)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            onClick: _cache[18] || (_cache[18] = ($event: any) => (changeAccessRule('allow'))),
                                            color: "green"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Liberar acesso ao painel ")
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_unref(collaborator).access_panel)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            onClick: _cache[19] || (_cache[19] = ($event: any) => (changeAccessRule('removeAllow'))),
                                            color: "red"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Remover acesso ao painel ")
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_divider, { class: "my-5" }),
                          (_unref(isEditPage))
                            ? (_openBlock(), _createBlock(RequestRefund, {
                                key: 1,
                                collaborator: _unref(collaborator)
                              }, null, 8, ["collaborator"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})